<template>
    <b-form @submit="onSubmit" v-bind:validated="formSubmitted">
        <b-row>
            <b-col>
                <b-form-group id="input-group-code" label-for="input-code">
                    <template v-slot:label>
                        <label-custom
                                label="Code ROME"
                                tooltip="Le format d'un code ROME correspond à une lettre en majuscule suivie de 4 chiffres"
                                :required="true">
                        </label-custom>
                    </template>
                    <b-form-input
                            id="input-code"
                            v-model="code.code"
                            type="text"
                            maxlength="5"
                            :pattern="regexCodeRome"
                            :trim="true"
                            required
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group id="input-group-libelle" label-for="input-libelle">
                    <template v-slot:label>
                        <label-custom
                                label="Intitulé du poste"
                                tooltip="Intitulé du poste"
                                :required="true">
                        </label-custom>
                    </template>
                    <b-form-input
                            id="input-libelle"
                            v-model="code.libelle"
                            type="text"
                            maxlength="255"
                            :trim="true"
                            required
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                        id="input-group-type"
                        label="Typologie de poste"
                        label-for="type"
                        label-class="typo-required-field">
                    <b-form-select
                            id="type"
                            v-model="code.type"
                            :options="typologies"
                            required>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                        id="input-group-poleEmploi"
                        label="Pôle Emploi"
                        label-for="poleEmploi"
                        label-class="typo-required-field">
                    <b-form-radio-group
                            id="poleEmploi"
                            v-model="code.poleEmploi"
                            :buttons="true"
                            button-variant="outline-primary"
                            required>
                        <b-form-radio :value="true">Oui</b-form-radio>
                        <b-form-radio :value="false">Non</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        id="input-group-presentSynthese"
                        label="Présent synthèse"
                        label-for="presentSynthese"
                        label-class="typo-required-field">
                    <b-form-radio-group
                            id="presentSynthese"
                            v-model="code.presentSynthese"
                            :buttons="true"
                            button-variant="outline-primary"
                            required>
                        <b-form-radio :value="true">Oui</b-form-radio>
                        <b-form-radio :value="false">Non</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="pt-2" align-h="center">
            <b-button type="submit" variant="primary" @click="formSubmitted = true">
                Modifier
            </b-button>
        </b-row>
    </b-form>
</template>

<script>

  import CodeRomeDto from "../../dtos/CodeRomeDto";
  import LabelCustom from "../../components/LabelCustom";
  import CodeRomeStore from "../../stores/CodeRomeStore";
  import {REGEX_CODE_ROME} from "../../constants/regex";
  import {TypologiePosteEnum} from "../../constants/enums";

  export default {
    name: 'ModifierCodeRome',
    components: {LabelCustom},
    props: {
      modalId: {
        type: String
      },
      value: {}
    },
    data() {
      return {
        code: new CodeRomeDto(),
        formSubmitted: false,
        regexCodeRome: REGEX_CODE_ROME,
        typologies: Object.entries(TypologiePosteEnum).map((value) => {
          return {text: value[1], value: value[0]};
        }),
      }
    },
    watch: {
      value: function (code) {
        this.initCode(code);
      }
    },
    mounted() {
      this.initCode(this.value);
    },
    methods: {
      initCode(code) {
        if (code) {
          this.code = Object.assign({}, code);
        } else {
          this.code = new CodeRomeDto();
        }
      },
      onSubmit(evt) {
        evt.preventDefault();
        CodeRomeStore.update(this.code, 'modifié').then(() => {
          this.$root.$emit('bv::hide::modal', this.modalId);
        });
      },
    }
  }
</script>

